export default {
  errors: {
    downloadPdfFailed: 'Nie udało się pobrać raportu jakości dla {report}. Jeśli błąd będzie się powtarzał, skontaktuj się z pomocą techniczną Qmulus.',
    contentUrlNotSet: 'Nie udało się ustalić adresu URL pliku PDF dla raportu {report}.',
  },
  longRunning: {
    summary: 'Generowanie raportu',
    detail: 'Generowanie raportu może chwilę potrwać. Proszę pozostawić otwarte okno przeglądarki. Ten komunikat zostanie zamknięty po zakończeniu żądania',
  },
};
